import { ROTransaction, RWTransaction } from '../../../db'
import { Context, Entity, Id } from '../../../common'

export enum RoleType {
  ADMIN = 'admin',
  OPERATOR = 'operator',
  MODERATOR = 'moderator',
  ANONYM = 'anonym',
}
export interface Role extends Entity {
  name: string
  description?: string
  permissions: string[]
  type: RoleType
}

export interface RolesRepository {
  findAll(tx: ROTransaction): Promise<Role[]>
  findById(tx: ROTransaction, id: Id): Promise<Role | undefined>
  findByIdNonDeleted(tx: ROTransaction, id: Id): Promise<Role | undefined>
  findByName(tx: ROTransaction, name: string): Promise<Role | undefined>
  save(tx: RWTransaction, role: Role): Promise<void>
  delete(tx: RWTransaction, id: Id, deletedAt: Date): Promise<void>
}

export interface AddRoleOpts {
  id?: string
  name: string
  description?: string
  permissions: string[]
  type: RoleType
}

export interface UpdateRoleOpts {
  name?: string
  description?: string
  permissions?: string[]
  type?: RoleType
}

export interface RolesService {
  findAll(ctx: Context): Promise<Role[]>
  getById(ctx: Context, id: Id): Promise<Role>
  findByIdNonDeleted(ctx: Context, id: Id): Promise<Role | undefined>
  add(ctx: Context, opts: AddRoleOpts): Promise<Id>
  update(ctx: Context, id: Id, opts: UpdateRoleOpts): Promise<void>
  addPermissions(ctx: Context, id: Id, permissions: string[]): Promise<void>
  deletePermissions(ctx: Context, id: Id, permissions: string[]): Promise<void>
}
